import type { ElementType, HTMLAttributes } from "react";
import s from "./Text.module.css";

export type TextSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
export type TextWeight = "regular" | "medium" | "bold";

export interface TextProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  size?: TextSize;
  weight?: TextWeight;
}

export function Text({ as: Component = "span", size = "md", weight = "regular", className, ...rest }: TextProps) {
  const classes = className
    ? `${s.root} ${s[`size-${size}`]} ${s[`weight-${weight}`]} ${className}`
    : `${s.root} ${s[`size-${size}`]} ${s[`weight-${weight}`]}`;
  return <Component className={classes} {...rest} />;
}
